import React from "react";
import {
    MdPeople,
    MdVerifiedUser,
    MdSecurity,
    MdLockOpen
} from "react-icons/md";

const UserSecuritySummary = ({ summary }) => {

    const cards = [

        {
            title: "Total Users",
            value: summary.totalUsers,
            color: "#2563eb",
            icon: <MdPeople size={28} />
        },

        {
            title: "Active Users",
            value: summary.activeUsers,
            color: "#16a34a",
            icon: <MdVerifiedUser size={28} />
        },

        {
            title: "Users With Overrides",
            value: summary.usersWithOverrides,
            color: "#7c3aed",
            icon: <MdSecurity size={28} />
        },

        {
            title: "Additional Access",
            value: summary.additionalAccess,
            color: "#ea580c",
            icon: <MdLockOpen size={28} />
        }

    ];

    return (

        <div className="row mb-3">

            {

                cards.map(card => (

                    <div
                        className="col-lg-3 col-md-6 mb-3"
                        key={card.title}
                    >

                        <div
                            className="card shadow-sm h-100"
                            style={{
                                borderTop: `3px solid ${card.color}`
                            }}
                        >

                            <div className="card-body">

                                <div className="d-flex justify-content-between">

                                    <div>

                                        <div className="text-muted small">

                                            {card.title}

                                        </div>

                                        <h2 className="mt-2 mb-0">

                                            {card.value}

                                        </h2>

                                    </div>

                                    <div
                                        style={{
                                            color: card.color
                                        }}
                                    >

                                        {card.icon}

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                ))

            }

        </div>

    );

};

export default UserSecuritySummary;